export default {
    namespaced: true,
    state: {
        formState: {
            activeField: 0,
            subFields: {
                activeSubField: 0,
                isNext: true,
                subFieldsLength: 0,
                isComplete: false,
                isValid: false,
                isPrev: false,
                prevField: 0
            },
            activeGroup: {
                id: 0,
                description: ""
            },
            isNext: true,
            formLength: 0,
            isComplete: false,
            isValid: false,
            isPrev: false,
            prevField: 0
        },
        formFields: [],
        formData: {},
        objectives: {}
    },
    getters: {
        formState: state => state.formState,
        formFields: state => state.formFields,
        formData: state => state.formData,
        objectives: state => state.objectives,
        percentComplete: state => {
            if (state.formState.formLength > 0) {
                if (state.formState.isValid) {
                    return (state.formState.activeField / (state.formState.formLength - 1)) * 100
                } else {
                    return (state.formState.prevField / (state.formState.formLength - 1)) * 100
                }
            }
            return false
        },
        isLastField: state => {
            return state.formState.activeField >= state.formState.formLength - 1
        }
    },
    mutations: {
        saveFormState: (state, formState) => {
            state.formState = formState
        },
        saveObjectives: (state, objectives) => {
            state.objectives = objectives
        },
        saveFormFields: (state, fields) => {
            state.formFields = fields
        },
        saveFormData: (state, data) => {
            state.formData = data
        },
        saveFormFieldData: (state, payload) => {
            state.formData[payload.key] = payload.value
        },
        saveFormSubFieldData: (state, payload) => {
            state.formData[payload.field][payload.key] = payload.value
        }
    },
    actions: {
        saveFormState: (context, formState) => {
            context.commit("saveFormState", formState)
        },
        saveObjectives: (context, objectives) => {
            context.commit("saveObjectives", objectives)
        },
        saveFormFields: (context, fields) => {
            context.commit("saveFormFields", fields)
        },
        saveFormData: (context, data) => {
            context.commit("saveFormData", data)
        }
    }
}
